import React from "react";
import PropTypes from "prop-types"
import * as S from "./styles"


const starPosition = [0.5329253381342083, 0.21305935565052492, 0.7945352147802591, 0.6444489178670827, 0.61183606984068, 0.8237953087081034, 0.9170286229476858, 0.599878505672478, 0.9685476443869769, 0.40782594960979623, 0.15318318858539914, 0.9672834541698851, 0.971814651217416, 0.5158780269696992, 0.045427020394369855, 0.36576674230158446, 0.9731881241915019, 0.5722495573547299, 0.7547186214526527, 0.7516948669889809, 0.5215513132830969, 0.34846640977464993, 0.667525227334377, 0.7024749815516995, 0.42723923381714846, 0.24817141138874832, 0.9123457748966777, 0.6876618145282019, 0.14620810603114598, 0.2676411652411528, 0.7133583833771273, 0.24581763752047925, 0.5188361465142612, 0.3638424757428953, 0.9006113109511436, 0.417600013921813, 0.21387037386341845, 0.8773090525948937, 0.031126835210448567, 0.4762014888849131, 0.25785961566103266, 0.8594760782684958, 0.1873572701358901, 0.6915836646146818, 0.3123638411240752, 0.7833408370893986, 0.15130169772216817, 0.7626850814805293, 0.5217848271552381, 0.7392460087212249, 0.3508985496462851, 0.5615155004567036, 0.7351936597238748, 0.5575035499392169, 0.3721553598454652, 0.042381269457173465, 0.15896469223150222, 0.03739549777360285, 0.3079723641067096, 0.9823414963886865, 0.026416981328823086, 0.8909514069908009, 0.23284898386495234, 0.5380489035513056, 0.8383369914872025, 0.6699633545400314, 0.0016366827558973451, 0.688380254345367, 0.01139005400341131, 0.19982260556582232, 0.5969848228233008, 0.33109164201291064, 0.8069877636284182, 0.8686203081324522, 0.606732791104106, 0.7094383167908294, 0.11234202331443899, 0.13404065885677752, 0.4551083194454195, 0.20127301166766798, 0.8309554549596707, 0.7127089878989983, 0.3657353219705519, 0.22366128237152694, 0.8185205112307925, 0.7078438242868268, 0.7217626406246758, 0.6491168345613438, 0.596743050114602, 0.6540850131298848, 0.7658773556783836, 0.8488989743415563, 0.5217682834835173, 0.5633268118652637, 0.30689494088452496, 0.0716645480105309, 0.1721951294983175, 0.2226963077243791, 0.577875438600965, 0.4187104412663687]

const Sky = ({ stars = 50,  color="white" }) => {


  const maxStars = stars >= 98 ? 98 : stars
  const s = new Array(maxStars).fill(true);

  return s.map((star, index) => (
    <S.Star
      left={`${100 * starPosition[index]}vw`}
      top={`${100 * starPosition[index + 1]}vh`}
      dimension={`${3 * starPosition[index + 2]}px`}
      color={color}
      key={index}
    />
  ))
};


Sky.propTypes = {
  stars: PropTypes.number,
  color: PropTypes.string,
}

export default Sky
